import React, { Component } from "react";
import { config } from "../../config/config";
import { withAppState, getAppState } from "../../state";
import { SplashStyled, ContainerStyled, LogoStyled, LoadingStyled } from "./styles/Styled";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { routes } from "../../routes";
import { showForceLogoutError, showUserAccountCallFailedModal } from "../../services/modalsService";
import FreeLogo from "../../components/FreeLogo";
import { deleteCurrentProfileInIndexDB, getCurrentProfile } from "../../services/multipleProfilesService";
import { isKidsProfile } from "../../utils/multipleProfilesUtils";
import {
  checkVoucherEligiblity,
  checkeVoucherLGEligiblity,
  getEvoucherDeviceVailidity
} from "../../services/eVoucherEligibilityService";
import { getAuthInfo } from "../../services/tvodService";
import { trackEvent } from "../../services/analyticsService";
// FIXME: Setting timeout to artificially cause the Splash screen to be displayed for a while
// Once we do more stuff during the splash screen, the timer won't be necessary
const TEMPORARY_DELAY = 3000;

class Splash extends Component {
  constructor(props) {
    super(props);
    this.isVoucherActive = null;
    this.seteVoucherLGEligibility = this.seteVoucherLGEligibility.bind(this);
    this.proceedNavigation = this.proceedNavigation.bind(this);
  }

  async componentDidMount() {
    this.props.pauseNavigation();
    await config.get();
    // force logout checks
    if (!!getAppState().forceLogout) {
      this.props.resumeNavigation();
      await showForceLogoutError.call(this);
      return;
    } else if (!!getAppState().userAccountFailed) {
      this.props.resumeNavigation();
      await showUserAccountCallFailedModal.call(this);
      return;
    }
    const isPromotionEnabled = config.get().promotions.enabled;
    const isValid = await getEvoucherDeviceVailidity();
    if (isValid && isPromotionEnabled) {
      this.props.applicationState.appStarted === false && (await this.seteVoucherLGEligibility());
    }
    await this.proceedNavigation();
  }

  async seteVoucherLGEligibility() {
    const { country } = this.props.applicationState;
    try {
      const voucherEligibility = await checkeVoucherLGEligiblity(country);
      this.isVoucherActive = !!voucherEligibility;
    } catch (error) {
      console.log(error);
    }
  }

  componentWillUnmount() {
    this.props.resumeNavigation();
  }

  async proceedNavigation() {
    const {
      history,
      applicationState,
      stateActions: { setAppStartedValue, setCurrentProfileId }
    } = this.props;
    const isUserLoggedIn = !!applicationState.userLogged;
    const currentProfile = await getCurrentProfile();
    if (isUserLoggedIn && currentProfile) {
      await deleteCurrentProfileInIndexDB();
    }
    let path = !!this.isVoucherActive
      ? routes.promotions
      : !isUserLoggedIn
      ? routes.home
      : isUserLoggedIn && routes.profileSelector;

    // IMP Flow, need to call this method to get auth info for SPX token handling
    // TODO: Uncomment me after MW deployed
    await getAuthInfo();
    !!this.isVoucherActive && setAppStartedValue();
    setTimeout(() => {
      trackEvent("session_start", window.location.pathname, "session_start");
      history.replace(path);
    }, TEMPORARY_DELAY);
  }

  render() {
    return (
      <SplashStyled>
        <ContainerStyled>
          <LogoStyled>
            <FreeLogo height="3.43rem" />
          </LogoStyled>
          <LoadingStyled />
        </ContainerStyled>
      </SplashStyled>
    );
  }
}

export default withAppState(withSubtheme(Splash));
